module.exports = __webpack_public_path__ + "static/media/pictos-12.dfe6ab24.svg";